import { render, staticRenderFns } from "./OperationInspectionRecordInfo.vue?vue&type=template&id=1c7f01f3&scoped=true"
import script from "./OperationInspectionRecordInfo.vue?vue&type=script&lang=js"
export * from "./OperationInspectionRecordInfo.vue?vue&type=script&lang=js"
import style0 from "./OperationInspectionRecordInfo.vue?vue&type=style&index=0&id=1c7f01f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f01f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7f01f3')) {
      api.createRecord('1c7f01f3', component.options)
    } else {
      api.reload('1c7f01f3', component.options)
    }
    module.hot.accept("./OperationInspectionRecordInfo.vue?vue&type=template&id=1c7f01f3&scoped=true", function () {
      api.rerender('1c7f01f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationInspectionRecordInfo/OperationInspectionRecordInfo.vue"
export default component.exports